// technical
//import AstranovaCoding from "../assets/event-images/celestra-coding.jpg";
import BugBusters from "../assets/event-images/bug-busters.jpg";
// import WebMasters from "../assets/event-images/web-masters.jpg";
import Technicalquiz from "../assets/event-images/technical-quiz.jpg";
import Ideathon from "../assets/event-images/ideathon.jpg";
import Seminar from "../assets/event-images/seminar.jpg";
import Workshop from "../assets/event-images/workshop.jpg";
import Reversecoding from "../assets/event-images/reversecoding.jpg";
import RelayCoding from "../assets/event-images/relay-coding.jpg";
import CodeHunt from "../assets/event-images/code-hunt.png";
import PromptEngineering from "../assets/event-images/prompt-engineering.jpg";
import RapidCoding from "../assets/event-images/rapid-coding.jpg";
import iplauction from "../assets/event-images/iplauction.jpg";
import SquidGameImg from "../assets/event-images/squid.jpg";
// non-technical
import TreasureHunt from "../assets/event-images/treasurehunt.jpg";
import AnimeQuiz from "../assets/event-images/animequiz.jpg";
import codeunscramble from "../assets/event-images/codeunscramble.jpg"
import KollywoodQuiz from "../assets/event-images/moviequiz.jpg";
import DumbCharades from "../assets/event-images/dumb-charades.jpg";
import MaathiYosi from "../assets/event-images/maathi-yosi.jpg";

// Elite
import PaperPresentation from "../assets/event-images/paperpresentation.jpg";
// import Valorant from "../assets/event-images/valorant.jpg";
// import FreeFire from "../assets/event-images/freefire.jpg";

// technical
export const technicalEvents = [

  {
    id: 2,
    title: "Technical Quiz",
    href: "/events/technical-quiz",
    description:
      "Get ready to test your knowledge and sharpen your skills in the ultimate battle of the brains! It's a high-octane, adrenaline-fueled showdown that will put your expertise to the test.",
    imageUrl: Technicalquiz,
    date: 28,
  },
  {
    id: 3,
    title: "Code Hunt",
    href: "/events/code-hunt",
    description:
      "A fun game of technical treasure hunt where the players have to solve each level to reach the treasure. The game contains 3 major levels.",
    imageUrl: CodeHunt,
    date: 1,
  },
  {
    id: 4,
    title: "Code Golf",
    href: "/events/CodeGolf",
    description:
      "Join us for the event of programming competition where participants implement the solution with shortest time and space complexity wins the prize",
    imageUrl: BugBusters,
    date: 1,
  },


  {
    id: 7,
    title: "Blind Coding",
    href: "/events/BlindCoding",
    description:
      "Blind coding challenge the participants to write code without running or testing it during the competition.  Test cases are hidden, and no instant feedback or debugging tools are allowed. ",
    imageUrl: PromptEngineering,
    date: 28,
  },

  {
    id: 11,
    title: "Code Unscramble",
    href: "/events/CodeUnscramble",
    description:
      "Join us for an exciting programming competition where participants are presented with shuffled pseudocode for a series of problems and must rearrange it into the correct logical order.",
    imageUrl: codeunscramble,
    date: 28,
    // comingSoon: true,
  },
  {
    id: 11,
    title: "Relay Coding",
    href: "/events/RelayCoding",
    description:
      "Join us for Relay Coding, the ultimate team coding challenge! Collaborate, code in turns, and solve problems seamlessly to outpace the competition. Teamwork and speed are the keys to victory!",
    imageUrl: RelayCoding,
    date: 1,
    // comingSoon: true,
  },
];

// non-technical
export const nonTechnicalEvents = [
  {
    id: 1,
    title: "Treasure Hunt",
    href: "/events/treasure-hunt",
    description:
      "Embark on an exhilarating treasure hunt, solving cryptic clues and navigating through hidden challenges to unveil the ultimate prize in this thrilling and immersive adventure game. Uncover secrets, test your wits, and race against time to claim the coveted treasure!",
    imageUrl: TreasureHunt,
    date: 1,
  },
  {
    id: 2,
    title: "Anime Quiz",
    href: "/events/anime-quiz",
    description:
      "Gear up for an unforgettable anime quiz experience and showcase your anime knowledge like never before! Are you ready to rise to the challenge and claim your spot as the ultimate anime aficionado? Join us and let the quizzing begin!",
    imageUrl: AnimeQuiz,
    date: 28,
  },
  {
    id: 4,
    title: "Movies Mania",
    href: "/events/kollywood-quiz",
    description:
      "Dive into the enchanting realm of South Indian cinema with the 'Kollywood Quiz'! From timeless classics to contemporary blockbusters, test your Tamil cinema expertise in a friendly and entertaining competition. We celebrate the magic of Kollywood together. Don't miss this chance to showcase your love for Tamil cinema!",
    imageUrl: KollywoodQuiz,
    date: 1,
  },
  {
    id: 5,
    title: "Squid Game",
    href: "/events/squidgame",
    description:
      "Squid Game Events are a series of thrilling challenges inspired by classic childhood games, testing participants' skills, strategy, and survival instincts. Each game brings unique rules, eliminations, and opportunities to win!",
    imageUrl: SquidGameImg,
    date: 28, 
  },
  {
    id: 6,
    title: "Maathi Yosi",
    href: "/events/maathi-yosi",
    description:
      "Try your best to not answer the question! Reply to as many questions as you can without giving a logical answer to any of them. If your answer is even slightly related to the question, you're out!",
    imageUrl: MaathiYosi, // Yet to change
    date: 9,
  },
  {
    id: 7,
    title: "Dumb Charades",
    href: "/events/dumb-charades",
    description:
      "Dumb charades is a thrilling and hilarious twist on the classic charades game, where participants convey words or phrases without speaking, relying solely on gestures and expressions. It combines wit, creativity, and laughter, making it a perfect entertainment choice for a lively gathering.",
    imageUrl: DumbCharades, // Yet to change
    date: 9,
  },
];

// Elite Events
export const eliteEvents = [
  {
    id: 1,
    title: "Tik Tik TIk",
    href: "/events/Tiktiktik",
    description:
      "A thrilling 3-round competition that combines technical prowess, problem-solving, and detective skills to test your brainpower and teamwork. Each round brings unique challenges, and the cumulative score will determine the ultimate winner.",
    imageUrl: RelayCoding,
    date: 1,
  },
  {
    id: 2,
    title: "Rapid Coding",
    href: "/events/rapid-coding",
    description:
      "Dive into the thrill of rapid coding at our symposium! Solve standard coding questions within tight timeframes, showcasing your coding prowess under pressure. Earn points for each problem cracked accurately, and compete against the clock to claim the top spot!",
    imageUrl: RapidCoding,
    date: 28,
  },
];

export const flagship = [
  {
    id: 1,
    title: "IPL Auction",
    href: "/events/iplauction",
    description:
      "IPL Auction is a captivating picture-based guessing game where players decipher the correct answer by connecting images with the aid of provided clues.",
    imageUrl: iplauction,
    date: 28,
  },
  {
    id: 2,
    title: "Seminar",
    href: "/events/seminar",
    description:
      "Sakthi Vignesh, Software Team Lead for the Semiconductor Division at Kawasaki Robotics India, is set to deliver a seminar on Deep Learning.",
    imageUrl: Seminar,
    date: 1,
    // comingSoon: true,
  },
  {
    id: 3,
    title: "Workshop",
    href: "/events/workshop",
    description:
      "Vaishnav Rengan V, Senior Project Engineer at Soliton Technologies, will guide a hands-on journey through the Software Development Life Cycle (SDLC), covering server scripting, Figma, and Agile methodologies. ",
    imageUrl: Workshop,
    date: 1,
    // comingSoon: true,
  },
  {
    id: 4,
    title: "Paper Presentation",
    href: "/events/paper-presentation",
    description:
      "Action is the foundational key to success--Pablo Picasso. Elevate your ideas and let you ideas fly high along with your presentation.",
    imageUrl: PaperPresentation,
    date: 28,
  },
  {
    id: 5,
    title: "Project Expo",
    href: "/events/ProjectExpo",
    description:
      "Join us for the Project Expo, where innovation meets creativity! Showcase your groundbreaking projects, impress the judges, and compete for exciting prizes. Let your ideas shine!",
    imageUrl: Ideathon,
    date: 1,
  },
]


